<template>
  <section>
    <h1 class="text-center mt-2 mb-0">
      {{ $t('personalizedWalletCard.preview.title') }}
    </h1>
    <h2 class="text-center text-dark mx-3 px-lg-5 my-3 font-weight-bold" v-html="$t('personalizedWalletCard.preview.description')" />
    <div class="bg-card-preview mb-3 mt-4">
      <b-row align-h="center" class="text-center">
        <b-col col class="mb-3" sm="12" md="5" cols="12">
          <h2 class="mb-3">{{ frontLabel }}</h2>
          <span id="wallet-card-front-label" class="sr-only">{{ frontTitle }}</span>
          <div class="bg-white shadow-sm svg-rounded" v-html="frontSvg" />
        </b-col>
        <b-col col class="mb-3" sm="12" md="5" cols="12">
          <h2 class="mb-3 mt-3 mt-md-0">{{ backLabel }}</h2>
          <span id="wallet-card-back-label" class="sr-only">{{ backTitle }}</span>
          <div class="bg-white shadow-sm svg-rounded" v-html="backSvg" />
        </b-col>
      </b-row>
    </div>
    <!-- Increase Duplicate Cards/CTA buttons -->
    <b-row align-v="start">
      <b-col cols="12" md="4" class="text-left text-md-center mb-3 mb-mb-0">
        <h2>{{ $t('personalizedWalletCard.preview.duplicateTitle') }}</h2>
        <b-button-group class="mx-1 increase-duplicate">
          <b-button :title="`Decrease ${$t('personalizedWalletCard.preview.duplicateTitle')}`" variant="white" @click.prevent="decrease">
            <fa-icon :icon="['fas', 'minus']" />
          </b-button>
          <b-button readonly disabled class="counter font-weight-bold" variant="white">{{ counter }}</b-button>
          <b-button :title="`Increase ${$t('personalizedWalletCard.preview.duplicateTitle')}`" variant="white" @click.prevent="increase">
            <fa-icon :icon="['fas', 'plus']" />
          </b-button>
        </b-button-group>
      </b-col>
      <b-col cols="12" md="8" class="pl-md-0">
        <h2 class="text-dark text-left mb-5 additional" v-html="additional"></h2>
      </b-col>
    </b-row>
    <b-row align-h="end" align-v="center">
      <b-col lg="3" class="text-lg-right text-left mb-3">
        <b-link @click="$emit('remove')">
          <u>{{ $t('personalizedWalletCard.buttons.remove') }}</u>
        </b-link>
      </b-col>
      <b-col lg="3" class="pr-md-0 d-none d-lg-block">
        <b-button id="wallet-card-edit" variant="outline-primary" block @click="$emit('edit')">
          {{ $t('personalizedWalletCard.buttons.edit') }}
        </b-button>
      </b-col>
      <b-col lg="3" class="pr-0 d-none d-lg-block pr-lg-3">
        <b-button id="wallet-card-continue" type="submit" variant="primary" block :disabled="isButtonDisabled">
          {{ $t('personalizedWalletCard.buttons.confirm') }}
          <div v-if="itemLoading" role="status" class="fa-pulse float-right mt-1">
            <fa-icon :icon="['fas', 'spinner']" class="d-flex" />
            <span class="sr-only">{{ $t('dp.buttons.loading') }}</span>
          </div>
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="uploadDesignsError">
      <b-col offset-lg="6" xl="auto">
        <p class="text-danger mb-0 mt-md-2">{{ $t('personalizedWalletCard.preview.uploadError', [petName]) }}</p>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { NotificationMixins } from '@/mixins/notification';
import { LanguageCheckMixins } from '@/mixins/languageCheck';

export default {
  name: 'WalletCardPreview',
  mixins: [NotificationMixins, LanguageCheckMixins],
  props: {
    itemLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    uploadDesignsError: {
      type: Boolean,
      required: false,
      default: false,
    },
    backPreview: {
      type: String,
      default: '',
      required: false,
    },
    frontPreview: {
      type: String,
      default: '',
      required: false,
    },
    additional: {
      type: String,
      default: '',
      required: false,
    },
    backSvg: {
      type: String,
      default: null,
      required: false,
    },
    backLabel: {
      type: String,
      default: null,
      required: false,
    },
    backTitle: {
      type: String,
      default: '',
      required: false,
    },
    frontSvg: {
      type: String,
      default: null,
      required: false,
    },
    frontLabel: {
      type: String,
      default: null,
      required: false,
    },
    frontTitle: {
      type: String,
      default: '',
      required: false,
    },
    petName: {
      type: String,
      default: 'Pet',
      required: false,
    },
  },
  data() {
    return {
      counter: 0,
    };
  },
  computed: {
    isButtonDisabled() {
      return this.itemLoading || this.languageError;
    },
  },
  methods: {
    increase() {
      this.counter++;
    },
    decrease() {
      this.counter - 1 >= 0 ? this.counter-- : null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.additional {
  @media (max-width: 767px) {
    font-size: 1.25rem;
  }
}
.bg-card-preview {
  @media (min-width: 768px) {
    background-color: $dp-gray-3;
    padding: 130px 0;
  }
  .svg-rounded {
    border: 1px solid $dp-gray-3;
    overflow: hidden;
    border-radius: 12px;
  }
}
.increase-duplicate {
  border: 2px solid $dp-gray-3;
  border-radius: 12px;
  color: $dp-black;
  width: 100px;
  @media (min-width: 992px) {
    width: 130px;
  }
  button {
    padding: 4px;
    color: $dp-black;
    &.counter {
      font-size: 18px;
    }
  }
}
</style>
